export function tagManager(event_name, content) {
  window.gtag('event', event_name, content);
}
